import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import DashboardTab from '../DashboardTab'
import Phone from '../../shared/Phone'
import instagramImage from 'assets/instagram-multicolor.png'
import landingPageGradient from 'assets/landing_page_phone_gradient.png'

import { HELVETICA_ITALIC, SANS_SERIF } from '../../styles'

const HeaderContainer = styled.div`
  width: 100%;
  text-align: center;
  margin-top: 1em;
  margin-bottom: 1.5em;
  ${HELVETICA_ITALIC};
  font-size: 22pt;
`
const CardsBlock = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-around;
`
const CardContainer = styled.div`
  margin: 0 20px 20px 0;
  width: 180px;
  height: 380px;
  border: 4px solid '#fff';
  box-shadow: 0 2px 6px 1px rgba(144, 144, 144, 0.5);

  position: relative;
  cursor: pointer;
  transition: all 0.15s ease-out;
`
const CardTopContainer = styled.div`
  width: 100%;
  height: 55%;
  border-bottom: solid 0.5px #bebebe;
  display: flex;
  align-items: center;
  justify-content: center;
`
const CardBottomContainer = styled.div`
  width: 100%;
  text-align: center;
`
const Title = styled.div`
  margin-top: 1em;

  ${SANS_SERIF}
  text-transform: uppercase;
  font-size: 70%;
  font-weight: 900;
`
const Description = styled.div`
  margin-top: 1em;
  padding: 0 8%;
  font-size: 60%;
`
const PhoneContainer = styled.div`
  height: 70%;
  
  div:first-child {
    left: 0;
  }
`
const Instagram = styled.div`
  width: 3em;
  height: 3em;
  background: url('${props => props.image}') no-repeat;
  background-size: 100% auto;
`
const LandingPageScreen = styled.div`
  height: 100%;
  background: url('${props => props.image}') no-repeat;
  background-size: cover;
`

class TemplatesTypeSelector extends Component {

  renderCardInfo (title, description) {
    return (
      <CardBottomContainer>
        <Title>{title}</Title>
        <Description>{description}</Description>
      </CardBottomContainer>
    )
  }

  render () {
    return (
      <DashboardTab>
        <HeaderContainer>Choose an option to get started</HeaderContainer>
        <CardsBlock>
          <CardContainer onClick={() => this.props.onClick([1])}>
            <CardTopContainer>
              <Instagram image={instagramImage} />
            </CardTopContainer>
            {this.renderCardInfo('INSTAGRAM STORE', 'Choose this option to get started setting up your Instagram store.  Link your Instagram account, tag your products in your images, add the link to your bio.  Thats it!')}
          </CardContainer>

          <CardContainer onClick={() => this.props.onClick([0])}>
            <CardTopContainer>
              <PhoneContainer>
                <Phone>
                  <LandingPageScreen image={landingPageGradient} />
                </Phone>
              </PhoneContainer>
            </CardTopContainer>
            {this.renderCardInfo('LANDING PAGE', 'Create beautiful landing pages from any one of our templates to suit each marketing use case.')}
          </CardContainer>

        </CardsBlock>
      </DashboardTab>

    )
  }
}

TemplatesTypeSelector.defaultProps = {
  onClick: () => null,
}

TemplatesTypeSelector.propTypes = {
  onClick: PropTypes.func,
}

export default TemplatesTypeSelector



// WEBPACK FOOTER //
// ./src/components/dashboard/templatesTab/TemplatesTypeSelector.js